import { NewsletterModel } from '@modules/newsletter/newsletter-model';

const { fields } = NewsletterModel;

export default [
  fields.id,
  fields.name,
  fields.lastname,
  fields.email,
  fields.zipcode,
  fields.state,
  fields.createdAt
];
